webpackJsonp([126523225082832],{

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n        width: 60px;\n        height: 60px;\n    '], ['\n        width: 60px;\n        height: 60px;\n    ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactBodymovin = __webpack_require__(68);
	
	var _reactBodymovin2 = _interopRequireDefault(_reactBodymovin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var unfavoritingAnimation = {
	    v: '5.1.1',
	    fr: 29.9700012207031,
	    ip: 0,
	    op: 50.0000020365418,
	    w: 50,
	    h: 50,
	    nm: 'Affordable-AE',
	    ddd: 0,
	    assets: [],
	    layers: [{
	        ddd: 0,
	        ind: 1,
	        ty: 4,
	        nm: 'Coin Slot Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0]],
	                        o: [[0, 0]],
	                        v: [[31.881, 21.057]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 2,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[24.045, 21.057], [29.473, 21.057]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 2',
	            np: 2,
	            cix: 2,
	            ix: 2,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[4.443, 4.346], [-4.443, 4.346], [-4.443, -4.346], [4.443, -4.346]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [27.784, 25.403],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 3',
	            np: 2,
	            cix: 2,
	            ix: 3,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 899.000036617021,
	        st: 0,
	        bm: 0
	    }, {
	        ddd: 0,
	        ind: 3,
	        ty: 4,
	        nm: 'Line Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[26.762, 14.042], [26.764, 2.584]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 2,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'tm',
	            s: {
	                a: 1,
	                k: [{
	                    i: {
	                        x: [0.667],
	                        y: [1]
	                    },
	                    o: {
	                        x: [0.669],
	                        y: [0.021]
	                    },
	                    n: ['0p667_1_0p669_0p021'],
	                    t: 4,
	                    s: [100],
	                    e: [0]
	                }, {
	                    t: 19.0000007738859
	                }],
	                ix: 1
	            },
	            e: {
	                a: 1,
	                k: [{
	                    i: {
	                        x: [0.667],
	                        y: [1]
	                    },
	                    o: {
	                        x: [0.167],
	                        y: [0.167]
	                    },
	                    n: ['0p667_1_0p167_0p167'],
	                    t: 15,
	                    s: [100],
	                    e: [0]
	                }, {
	                    t: 28.0000011404634
	                }],
	                ix: 2
	            },
	            o: {
	                a: 0,
	                k: 0,
	                ix: 3
	            },
	            m: 1,
	            ix: 2,
	            nm: 'Trim Paths 1',
	            mn: 'ADBE Vector Filter - Trim',
	            hd: false
	        }],
	        ip: 0,
	        op: 899.000036617021,
	        st: 0,
	        bm: 0
	    }, {
	        ddd: 0,
	        ind: 5,
	        ty: 4,
	        nm: 'Coin Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 1,
	                k: [{
	                    i: {
	                        x: [0.833],
	                        y: [0.833]
	                    },
	                    o: {
	                        x: [0.167],
	                        y: [0.167]
	                    },
	                    n: ['0p833_0p833_0p167_0p167'],
	                    t: 0,
	                    s: [0],
	                    e: [100]
	                }, {
	                    t: 8.00000032584668
	                }],
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                s: true,
	                x: {
	                    a: 1,
	                    k: [{
	                        i: {
	                            x: [0.984],
	                            y: [1]
	                        },
	                        o: {
	                            x: [0.016],
	                            y: [0]
	                        },
	                        n: ['0p984_1_0p016_0'],
	                        t: 0,
	                        s: [25.5],
	                        e: [25.5]
	                    }, {
	                        t: 19.0000007738859
	                    }],
	                    ix: 3
	                },
	                y: {
	                    a: 1,
	                    k: [{
	                        i: {
	                            x: [0.808],
	                            y: [0.978]
	                        },
	                        o: {
	                            x: [0.6],
	                            y: [0.017]
	                        },
	                        n: ['0p808_0p978_0p6_0p017'],
	                        t: 0,
	                        s: [16],
	                        e: [38]
	                    }, {
	                        t: 19.0000007738859
	                    }],
	                    ix: 4
	                }
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -1.531], [1.53, 0], [0, 1.531], [-1.531, 0]],
	                        o: [[0, 1.531], [-1.531, 0], [0, -1.531], [1.53, 0]],
	                        v: [[2.771, 0], [0.001, 2.771], [-2.771, 0], [0.001, -2.771]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [26.76, 11.985],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 3,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 899.000036617021,
	        st: 0,
	        bm: 0
	    }, {
	        ddd: 0,
	        ind: 7,
	        ty: 4,
	        nm: 'Everything Else Outlines',
	        sr: 1,
	        ks: {
	            o: {
	                a: 0,
	                k: 100,
	                ix: 11
	            },
	            r: {
	                a: 0,
	                k: 0,
	                ix: 10
	            },
	            p: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 2
	            },
	            a: {
	                a: 0,
	                k: [25, 25, 0],
	                ix: 1
	            },
	            s: {
	                a: 0,
	                k: [100, 100, 100],
	                ix: 6
	            }
	        },
	        ao: 0,
	        shapes: [{
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[3.125, 1.15], [-3.125, 1.15], [-3.125, -1.15], [3.125, -1.15]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [9.762, 38.779],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 1',
	            np: 3,
	            cix: 2,
	            ix: 1,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[3.125, 1.15], [-3.125, 1.15], [-3.125, -1.15], [3.125, -1.15]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [9.762, 41.025],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 2',
	            np: 3,
	            cix: 2,
	            ix: 2,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [-0.403, 0], [0, -0.404]],
	                        o: [[0, -0.404], [0.404, 0], [0, 0]],
	                        v: [[-0.73, 0.365], [-0.001, -0.365], [0.73, 0.365]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [10.637, 24.142],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 3',
	            np: 2,
	            cix: 2,
	            ix: 3,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [-0.404, 0], [0, -0.404]],
	                        o: [[0, -0.404], [0.403, 0], [0, 0]],
	                        v: [[-0.73, 0.365], [0.001, -0.365], [0.73, 0.365]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [14.656, 24.142],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 4',
	            np: 2,
	            cix: 2,
	            ix: 4,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [35.994, 42.174],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 5',
	            np: 3,
	            cix: 2,
	            ix: 5,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [30.869, 42.174],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 6',
	            np: 3,
	            cix: 2,
	            ix: 6,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [21.494, 42.174],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 7',
	            np: 3,
	            cix: 2,
	            ix: 7,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[1.357, -1.001], [0.003, 1.001], [-1.357, 1.001], [-1.357, -1.001]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [16.744, 42.174],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 8',
	            np: 3,
	            cix: 2,
	            ix: 8,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0.377], [1.575, 0.51], [0, 0], [0, 0]],
	                        o: [[0, -1.745], [0, 0], [0, 0], [0.099, -0.345]],
	                        v: [[1.361, 1.286], [-1.361, -2.432], [-1.361, 2.432], [1.191, 2.366]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [16.748, 18.95],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 9',
	            np: 3,
	            cix: 2,
	            ix: 9,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[11.012, 29.278], [11.012, 29.125]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 10',
	            np: 3,
	            cix: 2,
	            ix: 10,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0]],
	                        v: [[9.117, 29.278], [9.117, 29.125]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 11',
	            np: 3,
	            cix: 2,
	            ix: 11,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, -2.968]],
	                        o: [[0, 0], [2.969, 0], [0, 0]],
	                        v: [[-2.688, 2.757], [-2.688, -2.757], [2.688, 2.618]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [18.075, 18.625],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 12',
	            np: 3,
	            cix: 2,
	            ix: 12,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[1.782, 0], [0, 0], [0, 1.783], [-1.783, 0], [0, 0], [0, -1.783]],
	                        o: [[0, 0], [-1.783, 0], [0, -1.783], [0, 0], [1.782, 0], [0, 1.783]],
	                        v: [[1.148, 3.227], [-1.147, 3.227], [-4.375, 0], [-1.147, -3.227], [1.148, -3.227], [4.375, 0]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [11.012, 29.254],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 13',
	            np: 3,
	            cix: 2,
	            ix: 13,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0.47, 0.47], [0.47, -0.47], [0, 0]],
	                        o: [[0, 0], [0.47, -0.47], [-0.471, -0.47], [0, 0], [0, 0]],
	                        v: [[-1.146, 2.053], [0.786, 0.121], [0.786, -1.583], [-0.919, -1.583], [-1.255, -1.246]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [43.655, 21.372],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 14',
	            np: 2,
	            cix: 2,
	            ix: 14,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[-3.5, -3.365], [-3.5, 3.512], [-0.787, 3.512], [3.5, -3.512]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [18.887, 37.662],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 15',
	            np: 3,
	            cix: 2,
	            ix: 15,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[-3.064, -3.105], [-3.064, 3.105], [-0.351, 3.105], [3.064, -2.491]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [37.702, 38.069],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 16',
	            np: 3,
	            cix: 2,
	            ix: 16,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[5.565, 0], [0, 0], [0, 5.564], [0, 0], [-3.237, 0], [0, 0], [0, -5.565], [0, 0]],
	                        o: [[0, 0], [-5.565, 0], [0, 0], [0, -3.237], [0, 0], [5.565, 0], [0, 0], [0, 5.564]],
	                        v: [[7.111, 10.077], [-7.111, 10.077], [-17.188, 0.001], [-17.188, -4.215], [-11.326, -10.077], [7.111, -10.077], [17.188, -0.001], [17.188, 0.001]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [26.825, 28.702],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 17',
	            np: 3,
	            cix: 2,
	            ix: 17,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0.377], [1.575, 0.511], [0, 0], [0, 0]],
	                        o: [[0, -1.746], [0, 0], [0, 0], [0.099, -0.346]],
	                        v: [[1.361, 1.286], [-1.361, -2.432], [-1.361, 2.432], [1.191, 2.367]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0, 0.458999992819, 0.788000009574, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [12.373, 18.625],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 18',
	            np: 3,
	            cix: 2,
	            ix: 18,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, -2.968]],
	                        o: [[0, 0], [2.969, 0], [0, 0]],
	                        v: [[-2.688, 2.757], [-2.688, -2.757], [2.688, 2.618]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [13.7, 18.625],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 19',
	            np: 3,
	            cix: 2,
	            ix: 19,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[-3.5, -3.939], [-3.5, 3.939], [-0.787, 3.939], [3.5, -3.085]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [33.013, 37.235],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 20',
	            np: 3,
	            cix: 2,
	            ix: 20,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[-3.5, -3.939], [-3.5, 3.939], [-0.787, 3.939], [3.5, -3.085]],
	                        c: false
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 1, 1, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [23.637, 37.235],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 21',
	            np: 3,
	            cix: 2,
	            ix: 21,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        o: [[0, 0], [0, 0], [0, 0], [0, 0]],
	                        v: [[3.125, 1.15], [-3.125, 1.15], [-3.125, -1.15], [3.125, -1.15]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'st',
	                c: {
	                    a: 0,
	                    k: [0.255000005984, 0.250999989229, 0.258999992819, 1],
	                    ix: 3
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 4
	                },
	                w: {
	                    a: 0,
	                    k: 1,
	                    ix: 5
	                },
	                lc: 2,
	                lj: 2,
	                nm: 'Stroke 1',
	                mn: 'ADBE Vector Graphic - Stroke',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [1, 0.773000021542, 0.039000002543, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [40.476, 39.312],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 22',
	            np: 3,
	            cix: 2,
	            ix: 22,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }, {
	            ty: 'gr',
	            it: [{
	                ind: 0,
	                ty: 'sh',
	                ix: 1,
	                ks: {
	                    a: 0,
	                    k: {
	                        i: [[0, -11.907], [11.907, 0], [0, 11.907], [-11.907, 0]],
	                        o: [[0, 11.907], [-11.907, 0], [0, -11.907], [11.907, 0]],
	                        v: [[21.559, 0], [0.001, 21.559], [-21.559, 0], [0.001, -21.559]],
	                        c: true
	                    },
	                    ix: 2
	                },
	                nm: 'Path 1',
	                mn: 'ADBE Vector Shape - Group',
	                hd: false
	            }, {
	                ty: 'fl',
	                c: {
	                    a: 0,
	                    k: [0.902000038297, 0.902000038297, 0.902000038297, 1],
	                    ix: 4
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 5
	                },
	                r: 1,
	                nm: 'Fill 1',
	                mn: 'ADBE Vector Graphic - Fill',
	                hd: false
	            }, {
	                ty: 'tr',
	                p: {
	                    a: 0,
	                    k: [25.071, 25.898],
	                    ix: 2
	                },
	                a: {
	                    a: 0,
	                    k: [0, 0],
	                    ix: 1
	                },
	                s: {
	                    a: 0,
	                    k: [100, 100],
	                    ix: 3
	                },
	                r: {
	                    a: 0,
	                    k: 0,
	                    ix: 6
	                },
	                o: {
	                    a: 0,
	                    k: 100,
	                    ix: 7
	                },
	                sk: {
	                    a: 0,
	                    k: 0,
	                    ix: 4
	                },
	                sa: {
	                    a: 0,
	                    k: 0,
	                    ix: 5
	                },
	                nm: 'Transform'
	            }],
	            nm: 'Group 23',
	            np: 2,
	            cix: 2,
	            ix: 23,
	            mn: 'ADBE Vector Group',
	            hd: false
	        }],
	        ip: 0,
	        op: 899.000036617021,
	        st: 0,
	        bm: 0
	    }],
	    markers: []
	};
	
	
	var AffordableIcon = function AffordableIcon(_ref) {
	    var autoplay = _ref.autoplay;
	
	
	    var AffordableIconContainer = _styledComponents2.default.div(_templateObject);
	
	    var bodymovinOptions = {
	        loop: true,
	        autoplay: { autoplay: autoplay },
	        prerender: true,
	        animationData: unfavoritingAnimation
	    };
	
	    return _react2.default.createElement(
	        AffordableIconContainer,
	        null,
	        _react2.default.createElement(_reactBodymovin2.default, { options: bodymovinOptions })
	    );
	};
	
	exports.default = AffordableIcon;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Heading = __webpack_require__(44);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Form = __webpack_require__(52);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _SubpageBodyStyles = __webpack_require__(55);
	
	var _LandingHeader = __webpack_require__(24);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var relativePath = ("/pages/have-it-made/");
	
	var SubpageBody = function SubpageBody(_ref) {
	    var children = _ref.children,
	        headerText = _ref.headerText,
	        subHeaderText = _ref.subHeaderText,
	        category = _ref.category,
	        formHeading = _ref.formHeading,
	        backgroundImages = _ref.backgroundImages;
	
	
	    var redirectOnSubmit = function redirectOnSubmit(state) {
	        var redirectRelativePath = headerText.toLowerCase();
	        if (state.isLeadForm) {
	            window.location.href = '' + relativePath + redirectRelativePath + '/thank-you?zip=' + state.values.zip;
	        } else {
	            window.location.href = '' + relativePath + redirectRelativePath + '/thanks';
	        }
	    };
	
	    return _react2.default.createElement(
	        _SubpageBodyStyles.SubpageBodyContainer,
	        {
	            backgroundImages: backgroundImages },
	        _react2.default.createElement(
	            'div',
	            { className: 'header-overlay' },
	            _react2.default.createElement('div', { className: 'header-overlay-filter' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'subpage-column-left' },
	            _react2.default.createElement(
	                'span',
	                { className: 'subpage-header' },
	                _react2.default.createElement(
	                    _Heading2.default,
	                    {
	                        headingSize: 'xxlarge',
	                        headingTag: 'h1',
	                        headingColor: _colors2.default.wsWhite },
	                    headerText
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'subpage-content' },
	                _react2.default.createElement(
	                    _Heading2.default,
	                    {
	                        headingSize: 'xlarge',
	                        headingTag: 'h2',
	                        headingColor: _colors2.default.grayscaleCoolGray11 },
	                    subHeaderText
	                ),
	                _react2.default.createElement(
	                    _SubpageBodyStyles.BodyCopyContainer,
	                    null,
	                    children
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'subpage-column-right' },
	            _react2.default.createElement(_Form2.default, { formTypes: { originWebApp: 'clayton-homes-website', originWebPageType: 'him-campaign-landing-page', originCampaign: 'him-2018', originWebFormCategory: category },
	                options: { formHeading: formHeading, redirect: redirectOnSubmit } })
	        )
	    );
	};
	
	exports.default = SubpageBody;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BodyCopyContainer = exports.SubpageBodyContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        display: table;\n        max-width: 1750px;\n        padding-left: 11.2%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 170px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 17px;\n            padding-top: 268px;\n            width: 483px;\n        }\n\n        .subpage-content {\n            padding-top: 35px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n        }\n        \n        .react-bodymovin-container {\n            height: 50px;\n            width: 50px;\n        }\n\n        h2 {\n            line-height: 1.14;\n            margin-bottom: 25px;\n        }\n\n        h3 {\n            font-size: 22px;\n            margin: 0;\n        }\n    }\n\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  \n        .movin-header svg {\n            height: 60px !important;\n            width: 60px !important;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        display: table;\n        padding-left: 5.4%;\n        width: 100%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 188px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 29px;\n            padding-top: 268px;\n            width: 375px;\n        }\n\n        .subpage-content {\n            padding-top: 44px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 32px;\n                letter-spacing: -.8px;\n            }\n\n            \n            h2 {\n                font-size: 30px;\n                letter-spacing: -2px;\n                line-height: 1;\n                margin-left: -5px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 60px;\n            width: 60px;\n        }\n\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        display: block;\n        padding-left: 15px;\n        width: 100%;\n\n        .subpage-column-left {\n            display: block;\n            padding-top: 202px\n        }\n\n        .subpage-column-right {\n            display: block;\n            padding-left: 0;\n            padding-right: 18px;\n            padding-top: 20px;\n            width: 100%;\n        }\n\n        .subpage-content {\n            padding-top: 30px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 33px;\n                letter-spacing: -.9px;\n            }\n\n            h2 {\n                font-size: 27px;\n                letter-spacing: -.5px;\n                line-height: 1.1;\n                margin-left: 0px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 65px;\n            width: 65px;\n        }\n\n    }\n'], ['\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        display: table;\n        max-width: 1750px;\n        padding-left: 11.2%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 170px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 17px;\n            padding-top: 268px;\n            width: 483px;\n        }\n\n        .subpage-content {\n            padding-top: 35px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n        }\n        \n        .react-bodymovin-container {\n            height: 50px;\n            width: 50px;\n        }\n\n        h2 {\n            line-height: 1.14;\n            margin-bottom: 25px;\n        }\n\n        h3 {\n            font-size: 22px;\n            margin: 0;\n        }\n    }\n\n    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  \n        .movin-header svg {\n            height: 60px !important;\n            width: 60px !important;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        display: table;\n        padding-left: 5.4%;\n        width: 100%;\n\n        .subpage-column-left {\n            display: table-cell;\n            padding-top: 188px\n        }\n\n        .subpage-column-right {\n            display: table-cell;\n            padding-left: 29px;\n            padding-top: 268px;\n            width: 375px;\n        }\n\n        .subpage-content {\n            padding-top: 44px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 32px;\n                letter-spacing: -.8px;\n            }\n\n            \n            h2 {\n                font-size: 30px;\n                letter-spacing: -2px;\n                line-height: 1;\n                margin-left: -5px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 60px;\n            width: 60px;\n        }\n\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        display: block;\n        padding-left: 15px;\n        width: 100%;\n\n        .subpage-column-left {\n            display: block;\n            padding-top: 202px\n        }\n\n        .subpage-column-right {\n            display: block;\n            padding-left: 0;\n            padding-right: 18px;\n            padding-top: 20px;\n            width: 100%;\n        }\n\n        .subpage-content {\n            padding-top: 30px;\n        }\n\n        .heading-component {\n            display: inline-block;\n            max-width: 600px;\n\n            h1 {\n                font-size: 33px;\n                letter-spacing: -.9px;\n            }\n\n            h2 {\n                font-size: 27px;\n                letter-spacing: -.5px;\n                line-height: 1.1;\n                margin-left: 0px;\n                margin-bottom: 25px;\n            }\n\n            h3 {\n                font-size: 22px;\n                margin: 0;\n            }\n        }\n        \n        .react-bodymovin-container {\n            height: 65px;\n            width: 65px;\n        }\n\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    color: ', ';\n    font-family: "source-sans-pro", sans-serif;\n    font-size: 16px;\n    line-height: 27px;\n'], ['\n    color: ', ';\n    font-family: "source-sans-pro", sans-serif;\n    font-size: 16px;\n    line-height: 27px;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageBodyContainer = exports.SubpageBodyContainer = _styledComponents2.default.div(_templateObject, _LandingPageStyles2.default.viewBreakpoints.desktop, _LandingPageStyles2.default.viewBreakpoints.tablet, _LandingPageStyles2.default.viewBreakpoints.mobile);
	
	var BodyCopyContainer = exports.BodyCopyContainer = _styledComponents2.default.div(_templateObject2, _colors2.default.grayscaleCoolGray08);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(42);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _CircleArrow = __webpack_require__(76);
	
	var _CircleArrow2 = _interopRequireDefault(_CircleArrow);
	
	var _SubpageFooterStyles = __webpack_require__(57);
	
	var _LandingFooter = __webpack_require__(53);
	
	var _LandingFooter2 = _interopRequireDefault(_LandingFooter);
	
	var _urlTools = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubpageFooter = function SubpageFooter(_ref) {
	    var linkNext = _ref.linkNext,
	        linkPrev = _ref.linkPrev,
	        textNext = _ref.textNext,
	        textPrev = _ref.textPrev;
	
	    return _react2.default.createElement(
	        _SubpageFooterStyles.SubpageFooterContainer,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'footer-nav' },
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-left' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: (0, _urlTools.getLinkWithQueryString)(linkPrev) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'standard-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 1)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hover-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 0)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'nav-text' },
	                        textPrev
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'footer-right' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: (0, _urlTools.getLinkWithQueryString)(linkNext) },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'nav-text' },
	                        textNext
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'standard-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 1)', circleDiameter: '33' })
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'hover-state' },
	                        _react2.default.createElement(_CircleArrow2.default, { circleColor: _colors2.default.secondaryRubberDucky, arrowColor: _colors2.default.grayscaleCoolGray11, backgroundColor: 'rgba(255, 197, 10, 0)', circleDiameter: '33' })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_LandingFooter2.default, null)
	    );
	};
	
	exports.default = SubpageFooter;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SubpageFooterContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    margin-top: 57px;\n\n    .footer-nav {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        max-width: 100%;\n    }\n    \n    .nav-text {\n        color: ', ';\n        font-family: \'acumin-pro\', sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 1.28;\n        letter-spacing: normal;\n        position: absolute;\n        top: 32%;\n        transform: translateY(-50%);\n    }\n    .footer-left {\n        position: relative;\n        width: 50%;\n\n        .nav-text {\n            left: 45px;\n        }\n        .circle-arrow {\n            transform: rotate(180deg);\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .footer-right {\n        position: relative;\n        text-align: right;\n        width: 50%;\n\n        .nav-text {\n            right: 45px;\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .circle-arrow {\n        display: inline-block;\n        margin-bottom: 12px;\n        max-width: 64px;\n    }\n\n    .footer-container {\n        color: ', ';\n        position: relative;\n\n        a {\n            color: ', ';\n\n            &:hover {\n                color: ', ';\n            }\n        }\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 1.58%;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 4%;\n        }\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        margin-top: 0;\n\n        .footer-nav {\n            margin: auto;\n            width: 80%;\n        }\n\n        .footer-right,\n        .footer-left {\n            a:hover {\n                .hover-state {\n                    display: none;\n                }\n                .standard-state {\n                    display: inline-block;\n                }\n            }\n        }\n    }\n'], ['\n    margin-top: 57px;\n\n    .footer-nav {\n        align-items: center;\n        display: flex;\n        justify-content: space-between;\n        max-width: 100%;\n    }\n    \n    .nav-text {\n        color: ', ';\n        font-family: \'acumin-pro\', sans-serif;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 1.28;\n        letter-spacing: normal;\n        position: absolute;\n        top: 32%;\n        transform: translateY(-50%);\n    }\n    .footer-left {\n        position: relative;\n        width: 50%;\n\n        .nav-text {\n            left: 45px;\n        }\n        .circle-arrow {\n            transform: rotate(180deg);\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .footer-right {\n        position: relative;\n        text-align: right;\n        width: 50%;\n\n        .nav-text {\n            right: 45px;\n        }\n        .hover-state {\n            display: none;\n        }\n        .standard-state {\n            display: inline;\n        }\n        svg {\n            height: 33px;\n            width: 33px;\n        }\n        a:hover {\n            .hover-state {\n                display: inline;\n            }\n            .standard-state {\n                display: none;\n            }\n        }\n    }\n    .circle-arrow {\n        display: inline-block;\n        margin-bottom: 12px;\n        max-width: 64px;\n    }\n\n    .footer-container {\n        color: ', ';\n        position: relative;\n\n        a {\n            color: ', ';\n\n            &:hover {\n                color: ', ';\n            }\n        }\n    }\n\n    /* - DESKTOP VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 1.58%;\n        }\n    }\n\n    /* - TABLET VIEW - */\n    @media screen and (', '){\n        .footer-nav {\n            margin: 0 4%;\n        }\n    }\n\n    /* - MOBILE VIEW - */\n    @media screen and (', '){\n        margin-top: 0;\n\n        .footer-nav {\n            margin: auto;\n            width: 80%;\n        }\n\n        .footer-right,\n        .footer-left {\n            a:hover {\n                .hover-state {\n                    display: none;\n                }\n                .standard-state {\n                    display: inline-block;\n                }\n            }\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageFooterContainer = exports.SubpageFooterContainer = _styledComponents2.default.div(_templateObject, _colors2.default.grayscaleCoolGray11, _colors2.default.grayscaleCoolGray06, _colors2.default.grayscaleCoolGray06, _colors2.default.grayscaleCoolGray08, _LandingPageStyles2.default.viewBreakpoints.desktop, _LandingPageStyles2.default.viewBreakpoints.tablet, _LandingPageStyles2.default.viewBreakpoints.mobile);

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-affordability-header.daa7a9d5.jpg";

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-affordability-mobile.7c029252.jpg";

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subpages-affordability-tablet.f9de8b86.jpg";

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _utils = __webpack_require__(45);
	
	var _AffordableIcon = __webpack_require__(476);
	
	var _AffordableIcon2 = _interopRequireDefault(_AffordableIcon);
	
	var _LandingHeader = __webpack_require__(24);
	
	var _LandingHeader2 = _interopRequireDefault(_LandingHeader);
	
	__webpack_require__(94);
	
	var _SubpageStyles = __webpack_require__(58);
	
	var _SubpageStyles2 = _interopRequireDefault(_SubpageStyles);
	
	var _SubpageBody = __webpack_require__(54);
	
	var _SubpageBody2 = _interopRequireDefault(_SubpageBody);
	
	var _SubpageFooter = __webpack_require__(56);
	
	var _SubpageFooter2 = _interopRequireDefault(_SubpageFooter);
	
	var _Analytics = __webpack_require__(18);
	
	var _ScriptTags = __webpack_require__(28);
	
	var _ScriptTags2 = _interopRequireDefault(_ScriptTags);
	
	var _ImageSets = __webpack_require__(77);
	
	var _ImageSets2 = _interopRequireDefault(_ImageSets);
	
	var _subpagesAffordabilityMobile = __webpack_require__(596);
	
	var _subpagesAffordabilityMobile2 = _interopRequireDefault(_subpagesAffordabilityMobile);
	
	var _subpagesAffordabilityTablet = __webpack_require__(599);
	
	var _subpagesAffordabilityTablet2 = _interopRequireDefault(_subpagesAffordabilityTablet);
	
	var _subpagesAffordabilityHeader = __webpack_require__(588);
	
	var _subpagesAffordabilityHeader2 = _interopRequireDefault(_subpagesAffordabilityHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Affordability = function Affordability(props) {
	
	    // save any utm params to local session cache
	    if (props.location && props.location.search) {
	        (0, _utils.saveUTMSessionParams)(props.location.search);
	    }
	
	    var backgroundImages = new _ImageSets2.default(_subpagesAffordabilityMobile2.default, _subpagesAffordabilityTablet2.default, _subpagesAffordabilityHeader2.default);
	
	    return _react2.default.createElement(
	        _SubpageStyles2.default,
	        { backgroundImages: backgroundImages },
	        _react2.default.createElement(_LandingHeader2.default, null),
	        _react2.default.createElement(
	            _SubpageBody2.default,
	            {
	                category: 'affordable',
	                headerText: 'Affordability',
	                formHeading: 'Get the home you want at a price you can afford.',
	                subHeaderText: 'Clayton Built\xAE Homes: The Smart Housing Choice' },
	            _react2.default.createElement(
	                'div',
	                { className: 'movin-header' },
	                _react2.default.createElement(_AffordableIcon2.default, null),
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Get the home you want at a price you can afford.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'body-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body-column-Left' },
	                    'The need for quality built, affordable housing in America has never been greater, and prefabricated housing is a great solution. Clayton Built\xAE homes are constructed in climate controlled building facilities where our homes are not subject to weather delays. This, coupled with being able to purchase many of our building materials, like lumber, flooring, sinks and cabinetry, in bulk allows us to save on building costs and keep our home prices affordable.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'body-column-right' },
	                    'When you choose Clayton Built\xAE, you choose a home that is built on a foundation of quality and durability, style and affordability. Make the smart housing decision, and get into the home of your dreams quicker and within your budget. '
	                )
	            )
	        ),
	        _react2.default.createElement(_SubpageFooter2.default, {
	            linkNext: '/quality',
	            linkPrev: '/style',
	            textNext: 'Quality',
	            textPrev: 'Style'
	        }),
	        _react2.default.createElement(_ScriptTags2.default, null),
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            {
	                onChangeClientState: _Analytics.onHelmetChangeClientState,
	                script: [{
	                    type: 'text/javascript',
	                    innerHTML: '\n                        if (typeof fbq !== \'undefined\'){\n                            fbq(\'track\', \'PageView\');\n                        }\n                        if (typeof gtag !== \'undefined\'){\n                            gtag(\'event\', \'page_view\', {\'send_to\': \'AW-1040796449\',\'dynx_itemid\': \'HIM2018\',\'dynx_pagetype\': \'Affordability\'});\n                            gtag(\'event\', \'conversion\', {\n                                \'allow_custom_scripts\': true,\n                                \'send_to\': \'DC-6346097/fall1003/fall10+standard\'\n                            });    \n                        }\n                    '
	                }]
	            },
	            _react2.default.createElement(
	                'title',
	                null,
	                'Have It Made | Affordability | Clayton Homes'
	            )
	        )
	    );
	};
	
	exports.default = Affordability;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-position: center top;\n    color: ', ';\n    display: block;\n    font-family: \'acumin-pro\', sans-serif;\n    \n    width: 100%;\n\n    .header-overlay {\n        background-repeat: no-repeat;\n        left: 0;\n        position: absolute;\n        top: 0;\n        z-index: ', ';\n        width: 100%;\n    }\n\n    .header-overlay-filter {\n        background-color: ', ';\n        height: 100%;\n        width: 100%;\n    }\n\n    @media screen and (', '){\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        display: table;\n\n        .movin-header {\n            margin-top: -2px;\n\n            & > div, & > h3 {\n                display: inline-block;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 4px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: table;\n            letter-spacing: -.35px;\n            margin-top: 2px;\n            padding-top: 15px;\n            width: 86%;\n        }\n        \n        .body-column-left {\n            display: table-cell;\n            width: 50%\n        }\n\n         .body-column-right {\n            display: table-cell;\n            padding-left: 25px;\n            width: 50%\n         }\n\n    }\n\n    \n    @media screen and (min-width: 1501px) {\n        .header-overlay {\n            background-size: 100% auto;\n        }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -8px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 10px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.30px;\n            margin-left: -3px;\n            margin-top: 16px;\n            padding-top: 24px;\n            width: 99%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n         .body-column-right {\n            display: block;\n            padding-left: 0;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: 100% auto;\n            height: 270px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -12px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                letter-spacing: -.1px;\n                line-height: 1.4;\n                padding-left: 12px;\n                padding-right: 20px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.33px;\n            line-height: 1.7;\n            margin-left: -1px;\n            margin-top: 7px;\n            padding-right: 15px;\n            padding-top: 20px;\n            width: 100%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n        .body-column-right {\n            display: block;\n            padding-left: 0px;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (max-width: 392px) {\n        .header-overlay {\n            background-size: auto 100%;\n        }\n    }\n'], ['\n    background-position: center top;\n    color: ', ';\n    display: block;\n    font-family: \'acumin-pro\', sans-serif;\n    \n    width: 100%;\n\n    .header-overlay {\n        background-repeat: no-repeat;\n        left: 0;\n        position: absolute;\n        top: 0;\n        z-index: ', ';\n        width: 100%;\n    }\n\n    .header-overlay-filter {\n        background-color: ', ';\n        height: 100%;\n        width: 100%;\n    }\n\n    @media screen and (', '){\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        display: table;\n\n        .movin-header {\n            margin-top: -2px;\n\n            & > div, & > h3 {\n                display: inline-block;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 4px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: table;\n            letter-spacing: -.35px;\n            margin-top: 2px;\n            padding-top: 15px;\n            width: 86%;\n        }\n        \n        .body-column-left {\n            display: table-cell;\n            width: 50%\n        }\n\n         .body-column-right {\n            display: table-cell;\n            padding-left: 25px;\n            width: 50%\n         }\n\n    }\n\n    \n    @media screen and (min-width: 1501px) {\n        .header-overlay {\n            background-size: 100% auto;\n        }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: auto 100%;\n            height: 265px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -8px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                padding-left: 10px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.30px;\n            margin-left: -3px;\n            margin-top: 16px;\n            padding-top: 24px;\n            width: 99%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n         .body-column-right {\n            display: block;\n            padding-left: 0;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (', '){\n        display: block;\n\n        .header-overlay {\n            background-image: url(\'', '\');\n            background-size: 100% auto;\n            height: 270px;\n        }\n\n        .movin-header {\n            display: table;\n            margin-left: -10px;\n            margin-top: -12px;\n\n            & > div, & > h3 {\n                display: table-cell;\n                vertical-align: middle;\n            }\n\n            h3 {\n                letter-spacing: -.1px;\n                line-height: 1.4;\n                padding-left: 12px;\n                padding-right: 20px;\n            }\n        }\n\n         .body-container {\n            border-top: 2px solid #d6d7d9;\n            display: block;\n            letter-spacing: -.33px;\n            line-height: 1.7;\n            margin-left: -1px;\n            margin-top: 7px;\n            padding-right: 15px;\n            padding-top: 20px;\n            width: 100%;\n        }\n        \n        .body-column-left {\n            display: block;\n            width: 100%;\n        }\n\n        .body-column-right {\n            display: block;\n            padding-left: 0px;\n            padding-top: 15px;\n            width: 100%;\n         }\n    }\n\n    @media screen and (max-width: 392px) {\n        .header-overlay {\n            background-size: auto 100%;\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(4);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _LandingPageStyles = __webpack_require__(11);
	
	var _LandingPageStyles2 = _interopRequireDefault(_LandingPageStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SubpageContainer = _styledComponents2.default.div(_templateObject, _colors2.default.grayscaleCoolGray11, _LandingPageStyles2.default.zIndices.headerOverlay, _LandingPageStyles2.default.grayFilter, _LandingPageStyles2.default.viewBreakpoints.desktop, function (props) {
	    return props.backgroundImages.desktopImage;
	}, _LandingPageStyles2.default.viewBreakpoints.tablet, function (props) {
	    return props.backgroundImages.tabletImage;
	}, _LandingPageStyles2.default.viewBreakpoints.mobile, function (props) {
	    return props.backgroundImages.mobileImage;
	});
	
	exports.default = SubpageContainer;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-affordability-js-63647dea57b4dfd7e056.js